import React from 'react';

export function Logo() {
    return (
        
        <img src='/image.png' height="120" style={{cursor: 'default'}} />
    );
}

